// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { KeywordSearchLinks_abstract } from './../../abstract/SagaBase/Objects/KeywordSearchLinks_abstract';
export class KeywordSearchLinks extends KeywordSearchLinks_abstract {}
